const listNamesConfig = {
  entityItemsNamePlural: "Playlists",
  entityItemName: "Playlist",
  areaAccessName: "Playlists"
};

export default listNamesConfig;